import range from 'lodash/range';
import sampleSize from 'lodash/sampleSize';
import { BannerTrustStoryblok } from 'storyblok-types';

export const getRandomBanners = (
  banners: BannerTrustStoryblok[],
  count: number = banners.length,
): BannerTrustStoryblok[] => {
  const bannersLength = banners?.length;
  const randomIndexes = sampleSize(
    range(bannersLength),
    bannersLength >= count ? count : bannersLength,
  );

  return randomIndexes.map((index) => banners?.[index]);
};
